import { useEffect, useState } from "react"
import { useGamesContext } from "contexts/GamesContext"
import { useStudentHub } from "contexts/StudentHubContext"
import { getScreenId } from "common/functions"

export const useGameTracker = () => {
  const { exercisesContent, exerciseContentIndex, countdownCompleted, isLoadingGameContent, isGameFinished } = useGamesContext()
  const [exercise, setExercise] = useState(null)
  const { setSessionActivityLog } = useStudentHub()

  useEffect(() => {
    if (!isLoadingGameContent) {
      setExercise(exercisesContent[exerciseContentIndex])
    } else {
      setExercise(null)
    }
  }, [exercisesContent, exerciseContentIndex, isLoadingGameContent])

  useEffect(() => {
    if (!countdownCompleted || exercise === null || isGameFinished) return;
    const gameSessionContentId = exercise?.gameSessionContentId
    if (
      gameSessionContentId > 0 &&
      countdownCompleted
    ) {
      setSessionActivityLog({
        gameSessionContentId,
        viewId: getScreenId("games"),
      })
    }
  }, [exercise, countdownCompleted, isGameFinished])
}

export default useGameTracker
